import { Grid } from "@mui/material";
import turismocriativo from 'components/assets/imagens/img-turismo-criativo.png';
import eventoSalvadorpc from 'components/assets/imagens/eventoSalvador-pc.jpg';
import botaoinscricao from 'components/assets/imagens/btn-inscricoes.png';
import { DeviceProvider, useDevice } from "components/DeviceContext.js";
import logoEvento from 'components/assets/imagens/img-evento.png'
import PalavraOrganizadores from "components/PalavraOrganizadores";

const Home = () => {
	const { isMobile, isLaptop } = useDevice();
	return (
		<DeviceProvider>
			<Grid container style={{
				paddingTop: '1em',
				backgroundImage: `url(${eventoSalvadorpc})`,
				backgroundAttachment: 'fixed',
				backgroundPosition: isMobile ? 'bottom' : 'center',
				backgroundSize: 'cover', 
				backgroundRepeat: 'no-repeat',
				display: 'flex',
				justifyContent: 'center',
			}} >
				<Grid item xs={12} sm={11} md={8} lg={8} xl={12} style={{
					backgroundRepeat: 'no-repeat',
					marginTop: isLaptop ? '4em' : '5em',
					justifyContent: 'space-around',
					marginLeft: isMobile ? '0' : '30em',
					display: 'flex',
				}}>
							<img
						src={logoEvento}
						alt="Logo do Evento"
						style={{
							maxWidth: '60%',
							objectFit: 'contain',
							maxHeight: isMobile ? '40%' :  isLaptop ? '40%' : '50%',

						}}
					/>
							<img
						src={turismocriativo}
						alt="Logo do Evento"
						style={{
							marginTop: isMobile ? '0' : '2em', 
							maxWidth: '50%',
							maxHeight: isMobile ? '40%' : isLaptop ? '35%' :  '50%',
							objectFit: 'contain'
						}}

					/>
			
				</Grid>
				<Grid item xs={12} sm={12} md={8} lg={8} xl={10} style={{
					backgroundRepeat: 'no-repeat',
					justifyContent: 'center',
					width: '90%',

				}}>
					<a href="https://intranet.cnm.org.br/223/22303001.asp?slCD_ORIGEM=851" target="_blank" rel="noopener noreferrer">
						<img
							src={botaoinscricao}
							alt="Logo do Evento"
							style={{
								objectFit: 'contain',
								maxHeight: isMobile ? '30%' : isLaptop ?  '60%' : '50%',
								width: '100%',
								marginTop: isMobile ? '0' : '-4em',
								transition: 'transform 0.3s ease-in-out',
								marginBottom: '10em'
							}}
							onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'} 
							onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}  
						/>
					</a>
				</Grid>

				<PalavraOrganizadores/ > 
			</Grid >
		</DeviceProvider>
	);
}

export default Home;
